import { render, staticRenderFns } from "./tpms-list.vue?vue&type=template&id=0796fad4&"
import script from "./tpms-list.vue?vue&type=script&lang=js&"
export * from "./tpms-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports